
import EditorTipTap from 'Editors/EditorTipTap'
import EditorList from 'Editors/EditorList'
import ControllerContactForm from 'Controllers/ControllerContactForm'

export default {
  components: {
    EditorList,
    EditorTipTap,
    ControllerContactForm,
  },
  data() {
    return {
      privacy: false,
      thankYouMessage: false,
      options: [
        {
          name: 'title',
          label: 'Glavni naslov',
          type: 'text',
        },
      ],
      optionsSec: [
        {
          name: 'title',
          label: 'Glavni naslov',
          type: 'tipTap',
        },
      ],
      interneOpcije: [
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'tipTap',
        },
      ],
      interneOpcijeSec: [
        {
          name: 'logo',
          label: 'Logo',
          type: 'image',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'tipTap',
        },
      ],
    }
  },
  mounted() {
    this.thankYouMessage = false
  },
  methods: {
    changeStatement() {
      this.privacy = !this.privacy
    },
    thankYou() {
      this.thankYouMessage = true
      if (process.browser) {
        window.scrollTo(0, 0)
      }
    },
  },
}
